<template>
  <a-layout id="components-layout-demo-top" class="layout">
    <a-layout-content class="layout-content">
      <div class="home-toolbar">
        <a-breadcrumb>
          <a-breadcrumb-item>{{ $t("Home") }}</a-breadcrumb-item>
        </a-breadcrumb>
        <div class="change-locale">
          <a-radio-group
            :default-value="enUS"
            @change="changeLocale"
            :value="currentLang"
          >
            <a-radio-button key="en" :value="enUS"> English </a-radio-button>
            <a-radio-button key="cn" :value="zhCN"> 中文 </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      
      <div class="mt-15">
        <h1>{{ $t("Welcome") }}</h1>
        <p>{{ $t("Please select the function you want to use") }}</p>
      </div>

      <a-row type="flex" justify="start" :gutter="[20, 20]" class="function-cards">
        <a-col class="function-col" :xs="24" :sm="12" :md="8" :lg="8" :xl="8" :xxl="6">
          <a-card 
            :bordered="false" 
            class="function-card"
            @click.native="navigateToMetafields"
          >
            <div class="card-content">
              <a-icon type="database" class="card-icon" />
              <h2>{{ $t("Metafields Import") }}</h2>
              <p>{{ $t("Import metafields data to your store") }}</p>
            </div>
          </a-card>
        </a-col>
        
        <a-col class="function-col" :xs="24" :sm="12" :md="8" :lg="8" :xl="8" :xxl="6">
          <a-card 
            :bordered="false" 
            class="function-card"
            @click.native="navigateToProductImport"
          >
            <div class="card-content">
              <a-icon type="shopping" class="card-icon" />
              <h2>{{ $t("Product Template Import") }}</h2>
              <p>{{ $t("Batch import product templates and collections") }}</p>
            </div>
          </a-card>
        </a-col>
        
        <a-col class="function-col" :xs="24" :sm="12" :md="8" :lg="8" :xl="8" :xxl="6">
          <a-card 
            :bordered="false" 
            class="function-card"
            @click.native="navigateToLogs"
          >
            <div class="card-content">
              <a-icon type="file-text" class="card-icon" />
              <h2>{{ $t("Operation Logs") }}</h2>
              <p>{{ $t("View operation logs and task status") }}</p>
            </div>
          </a-card>
        </a-col>
        
        <a-col class="function-col" :xs="24" :sm="12" :md="8" :lg="8" :xl="8" :xxl="6">
          <a-card 
            :bordered="false" 
            class="function-card"
            @click.native="navigateToExport"
          >
            <div class="card-content">
              <a-icon type="export" class="card-icon" />
              <h2>{{ $t("Metafields Export") }}</h2>
              <p>{{ $t("Export metafields to Excel") }}</p>
            </div>
          </a-card>
        </a-col>

        <a-col class="function-col" :xs="24" :sm="12" :md="8" :lg="8" :xl="8" :xxl="6">
          <a-card 
            :bordered="false" 
            class="function-card"
            @click.native="navigateToPricing"
          >
            <div class="card-content">
              <a-icon type="rocket" class="card-icon" />
              <h2>{{ $t("Pricing Plans") }}</h2>
              <p>{{ $t("View our pricing plans and upgrade") }}</p>
            </div>
          </a-card>
        </a-col>
      </a-row>

      <div v-if="showRecentActivity" class="mt-30">
        <a-card :bordered="false">
          <h3>{{ $t("Recent Activity") }}</h3>
          <a-empty 
            :description="$t('No recent activity')"
            :image="simpleImage"
          />
        </a-card>
      </div>
    </a-layout-content>
    
    <a-layout-footer style="text-align: center">
      {{ $t("Smart Import System") }} ©2026 Created by Tayun Team
    </a-layout-footer>
  </a-layout>
</template>

<script>
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import { loadLanguageAsync } from "@/locales";
import storage from "store";
import { Empty } from 'ant-design-vue';

export default {
  data() {
    return {
      enUS,
      zhCN,
      locale: enUS,
      currentLang: enUS,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      showRecentActivity: false
    };
  },
  created() {
    this.initLang();
  },
  methods: {
    initLang() {
      let lang = storage.get("lang");
      if (lang) {
        if (lang === "zh-CN") {
          loadLanguageAsync("zh-CN");
          moment.locale("zh-cn");
          this.locale = zhCN;
          this.currentLang = zhCN;
        }
        if (lang === "en-US") {
          loadLanguageAsync("en-US");
          moment.locale("en");
          this.locale = enUS;
          this.currentLang = enUS;
        }
      }
    },
    changeLocale(e) {
      const localeValue = e.target.value;
      this.locale = localeValue;
      if (localeValue.locale === "zh-cn") {
        loadLanguageAsync("zh-CN");
        this.currentLang = zhCN;
      }
      if (localeValue.locale === "en") {
        loadLanguageAsync("en-US");
        this.currentLang = enUS;
      }
      if (!localeValue) {
        moment.locale("en");
      } else {
        moment.locale("zh-cn");
      }
    },
    navigateToMetafields() {
      this.$router.push('/metafields');
    },
    navigateToProductImport() {
      this.$router.push('/product-import');
    },
    navigateToLogs() {
      this.$router.push('/logs');
    },
    navigateToExport() {
      this.$router.push('/export');
    },
    navigateToPricing() {
      this.$router.push('/pricing');
    }
  }
};
</script>

<style scoped>
.layout-content {
  padding: 0 50px;
  flex: 1;
}

.home-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
  gap: 12px;
}

@media screen and (max-width: 768px) {
  .layout-content {
    padding: 0 24px;
  }
}

@media screen and (max-width: 576px) {
  .layout-content {
    padding: 0 16px;
  }
}

.mt-15 {
  margin-top: 15px;
}

.mt-30 {
  margin-top: 30px;
}

.function-cards {
  margin-top: 30px;
}

.function-col {
  display: flex;
}

.function-card {
  cursor: pointer;
  height: 220px;
  width: 100%;
  transition: transform 0.2s, box-shadow 0.2s;
}

.function-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.card-content {
  text-align: center;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.card-icon {
  font-size: 36px;
  color: #1890ff;
  margin-bottom: 12px;
}

.card-content h2 {
  margin-bottom: 8px;
  color: #262626;
  font-size: 18px;
}

.card-content p {
  color: #8c8c8c;
  margin-bottom: 0;
  line-height: 1.5;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .home-toolbar {
    align-items: flex-start;
  }

  .function-card {
    height: 200px;
  }

  .card-icon {
    font-size: 32px;
  }

  .card-content h2 {
    font-size: 16px;
  }

  .card-content p {
    font-size: 12px;
  }

  h1 {
    font-size: 24px !important;
  }
}

@media screen and (max-width: 576px) {
  .home-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }

  .change-locale {
    width: 100%;
  }

  .change-locale .ant-radio-group {
    width: 100%;
    display: flex;
  }

  .change-locale .ant-radio-button-wrapper {
    flex: 1;
    text-align: center;
  }

  .function-cards {
    margin-top: 20px;
  }

  .function-card {
    height: 180px;
  }

  .card-content {
    padding: 12px 10px;
  }

  .card-icon {
    font-size: 28px;
  }

  .card-content h2 {
    font-size: 15px;
  }

  .card-content p {
    font-size: 11px;
  }

  h1 {
    font-size: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue